import { Controller } from "@hotwired/stimulus";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default class extends Controller {
  static targets = [
    "submitButton",
    "cancelButton",
    "input",
    "radioButtonsNaturePlan",
    "radioButtonsHeures",
    "form",
    "skipMailing",
    "select",
  ];

  sendAlertWhenCancel() {
    Swal.fire({
      html: "Vous êtes sur le point de quitter le plan de prévention.<br />Vos données ne seront pas enregistrées. Etes-vous sûr ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: '<a href="/pps">Quitter</a>',
      cancelButtonText: "Annuler",
      closeOnConfirm: false,
      closeOnCancel: false,
    });
  }

  sendAlertWhenInvalid() {
    if (this.submitButtonTarget.disabled) {
      Swal.fire({
        title: "Attention !",
        text: "Avant de valider cette demande, assurez-vous d'avoir rempli tous les champs.",
        icon: "error",
        confirmButtonText: "Continuer",
      });
    }
  }

  sendAlertWhenValid() {
    if (this.submitButtonTarget.disabled === false) {
      Swal.fire({
        html: "Votre demande a bien été envoyée à l'entreprise",
        icon: "success",
        showCancelButton: true,
      });
      this.formTarget.submit();
    }
  }

  enableSubmitIfAllInputFilled() {
    // Wonderfully stupid bug where any of the radio buttons need to be clicked to actually trigger the if statement correctly
    if (
      this.inputTargets.every((target) => target.value !== "") &&
      this.selectTargets.every((target) => target.selectedIndex !== 0)
    ) {
      this.submitButtonTarget.disabled = false;
    } else {
      this.submitButtonTarget.disabled = true;
    }
  }

  submitForm() {
    this.skipMailingTarget.value = "1";
    this.formTarget.submit();
  }
}
